import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_contact_form = _resolveComponent("company-contact-form")!

  return (_openBlock(), _createBlock(_component_company_contact_form, {
    form: _ctx.form,
    path: "/supplier/company/contact"
  }, null, 8, ["form"]))
}